module.exports = __webpack_public_path__ + "img/f4p_login.bd62c3a1.png";